export enum VariableRowState {
  EDITABLE = 'editable',
  EDITING = 'editing',
  EDITING_VALUE_ONLY = 'editing-value-only',
  READONLY = 'readonly',
}
